module.exports = __webpack_public_path__ + "static/media/HCMM308.1eb799f3.jpg";